import React, { useState, useRef, useEffect, useCallback } from 'react';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import calender from '../../assets/images/calendar.png';
import axios from 'axios';
import { UPDATE_PASSENGER, GET_STATE_URI, GET_DRIVER_LIST, GET_EDIT_PASSENGER, GET_DELETE_ASSIGNED_DRIVER, GET_ALL_PAYER } from '../../constant';
import { Circles } from 'react-loader-spinner';
//import Swal from '../../../node_modules/sweetalert2/dist/sweetalert2';
import Swal from '../../messageBox/customSweetAlert';
import { InputMask } from "primereact/inputmask";
import SaveButton from '../../components/buttons/SaveButton';
import CancelButton from '../../components/buttons/CancelButton'
import { currentDateFormat, restrictZipInput, allowOnlyNumberKey } from "../../utils";
import { useParams } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.min.css';
import moment from 'moment';
import { useNavigate } from "react-router-dom";
import { passengerFormValidation } from "../../validation/Validation";
import Calender from "../../components/Calendar";
import { useDispatch, useSelector } from 'react-redux';
import { setLoading } from '../../redux/loaderAction';
import Loader from '../../components/loader/Loader';


function PassengerView() {
    const dispatch = useDispatch();
    const loading = useSelector((state) => state.loader.loading);
    const { id } = useParams();
    const navigate = useNavigate();

    // Scroll to top when entering the page (e.g. from Edit in PassengerTable)
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [id]);
    let currentInputIndex = 0;
    const [errors, setErrors] = useState({});
    const checkboxRef = useRef(null);
    const [birthDate, setBirthDate] = useState();
    const [startDate, setStartDate] = useState();
    const [stateData, setStateData] = useState([]);
    const [userData, setUserData] = useState({});
    const [currentDate, setCurrentDate] = useState(new Date());
    //const [loading, setLoading] = useState(false);
    const inputRef = useRef(null);
    const formRef = useRef({});
    const [myArray, setMyArray] = useState([]);
    const [driverDetails, setDriverDetails] = useState([]);
    const [editDriverDetails, setEditDriverDetails] = useState();
    const [suggestions, setSuggestions] = useState([]);
    const [viewDetails, setViewDetails] = useState();
    const [passengerDetails, setPassengerDetails] = useState({
        first_name: '',
        middle_name: '',
        last_name: '',
        preferred_name: '',
        gender: '',
        driverIds: [],
        insurance_number: '',
        pmi_number: '',
        payer: '',
        location: '',
        address_line_one: '',
        address_line_two: '',
        state: '',
        zip: '',
        home_phone: '',
        cell_phone: '',
        pick_phone: '',
        alternative_phone: '',
        username: '',
        email_address: '',
        home_type: '',
        mode: '',
        weight: '',
        wc_expiry_date: '',
        oxy_yes: '',
        oxy_no: '',
        bari_yes: '',
        bari_no: '',
        e_first_name: '',
        e_last_name: '',
        e_cell_number: '',
        e_email: '',
        r_first_name: '',
        r_last_name: '',
        r_cell_number: '',
        r_email: '',
        passId: id,
        diagnosis_code: '',
        city: '',
        county: '',
        date_of_birth: '',
        oxy: '',
        bari: '',
        visit_frequency: '',
        userIds: []
    });
    //     'Authorization': `Bearer ${localStorage.getItem('userData')}`,
    //     'Content-Type': 'application/json',
    //     'User': JSON.stringify(userData)
    //   };
    const [payerList, setPayerList] = useState([]);
    const [passengerDataLoading, setPassengerDataLoading] = useState(true);
    const [isUpdatingPassenger, setIsUpdatingPassenger] = useState(false);
    const handleFormSubmit = useCallback(async (e) => {
        e.preventDefault();
        const isValid = passengerFormValidation(passengerDetails, { forEdit: true });
        setErrors(isValid);
        if (Object.keys(isValid).length === 0) {
            setIsUpdatingPassenger(true);
            dispatch(setLoading(true));
            try {
                const payload = {
                    ...passengerDetails,
                    pmi_number: passengerDetails.pmi_number ?? '',
                    payer: passengerDetails.payer != null && passengerDetails.payer !== ''
                        ? String(passengerDetails.payer)
                        : '',
                    zip: passengerDetails.zip != null ? String(passengerDetails.zip) : '',
                    gender: passengerDetails.gender != null && passengerDetails.gender !== ''
                        ? String(passengerDetails.gender)
                        : '',
                };
                const response = await axios.post(UPDATE_PASSENGER, payload);
                if (response.data.status === '200') {
                    Swal.fire({
                        title: 'Success!',
                        text: response.data.message,
                        icon: 'success',
                        confirmButtonText: 'OK',
                    });
                    navigate('/home/passenger/list', { replace: true });

                } else {
                    Swal.fire({
                        title: 'Error!',
                        text: response.data.message,
                        icon: 'Error',
                        confirmButtonText: 'OK',
                    });
                }
            } catch (error) {
                console.error("Error logging in:", error);
            } finally {
                setIsUpdatingPassenger(false);
                dispatch(setLoading(false));
            }
        }
    }, [passengerDetails, dispatch, navigate]);
    // {console.log("passengerDetails",passengerDetails)}
    const loadUser = useCallback(async () => {
        setPassengerDataLoading(true);
        dispatch(setLoading(true));
        try {
            const result = await axios.get(GET_DRIVER_LIST);
            const response_2 = await axios.get(GET_EDIT_PASSENGER + '/' + `${id}`);
            const response_state = await axios.get(GET_STATE_URI);
            const response_payer = await axios.get(GET_ALL_PAYER);
            setStateData(response_state.data);
            setPayerList(response_payer.data);
            setDriverDetails(result.data);
            // Root record: top-level user/passenger fields + nested `passenger` object (p)
            const d = response_2?.data?.data ?? response_2?.data?.passenger ?? response_2?.data;
            const p = d?.passenger;
            setViewDetails(d);
            if (d?.user_dob) {
                const [year, month, day] = String(d.user_dob).split("-");
                setBirthDate(new Date(parseInt(year, 10), parseInt(month, 10) - 1, parseInt(day, 10)));
            }
            setStartDate(p?.pass_wc_expired_date ?? null);
            if (d) {
                setPassengerDetails({
                    first_name: (d.passenger_first_name ?? '').trim(),
                    middle_name: (d.passenger_middle_name ?? '').trim(),
                    last_name: (d.passenger_last_name ?? '').trim(),
                    preferred_name: (d.preferred_name ?? '').trim(),
                    driverIds: [],
                    gender: d.gender != null && d.gender !== '' ? String(d.gender) : '',
                    date_of_birth: d.user_dob ? moment(d.user_dob).format('DD/MM/yyyy') : '',
                    insurance_number: p?.pass_insurance_no ?? '',
                    pmi_number: p?.pass_pmi_no != null ? String(p.pass_pmi_no) : '',
                    payer: p?.pass_payer != null ? String(p.pass_payer).trim() : '',
                    location: p?.pass_location ?? '',
                    address_line_one: d.address_1 ?? '',
                    address_line_two: d.address_2 ?? '',
                    city: d.city ?? '',
                    state: d.state != null ? String(d.state) : '',
                    zip: d.zip != null ? String(d.zip) : '',
                    home_phone: p?.pass_home_phn_no ?? '',
                    cell_phone: p?.pass_cell_phn ?? d?.mobile_no ?? '',
                    pass_county: p?.pass_county ?? '',
                    county: p?.pass_county ?? '',
                    pick_phone: '',
                    alternative_phone: p?.pass_alternative_phn ?? '',
                    email_address: d.user_email ?? '',
                    username: d.username ?? '',
                    home_type: p?.pass_home_type != null ? String(p.pass_home_type) : '',
                    mode: p?.pass_mode != null ? String(p.pass_mode) : '',
                    weight: p?.pass_weight != null ? String(p.pass_weight) : '',
                    wc_expiry_date: p?.pass_wc_expired_date ? moment(p.pass_wc_expired_date).format('DD/MM/yyyy') : '',
                    oxy: p?.pass_need_oxygen ?? null,
                    oxy_no: '',
                    bari: p?.pass_need_bariatric ?? null,
                    bari_no: '',
                    e_first_name: d.emergency_contact_name ?? '',
                    e_last_name: '',
                    e_cell_number: d.emergency_phn ?? '',
                    e_email: d.emergency_email ?? '',
                    r_first_name: p?.resp_party_first_name ?? '',
                    r_last_name: p?.resp_party_last_name ?? '',
                    r_cell_number: p?.resp_party_phn_no ?? '',
                    r_email: p?.resp_party_email ?? '',
                    diagnosis_code: p?.diagnosis_code ?? '',
                    userIds: [],
                    passId: id,
                    visit_frequency: p?.visit_frequency != null ? String(p.visit_frequency) : '',
                });
            }
        } catch (error) {
            console.error("Error loading passenger:", error);
        } finally {
            setPassengerDataLoading(false);
            dispatch(setLoading(false));
        }
    }, [id]);

    useEffect(() => {
        loadUser();
    }, [loadUser]);


    const handleInputChange = useCallback((e) => {
        const { name, value } = e.target;
        setErrors((prevErrors) => ({ ...prevErrors, [name]: null }));
        setPassengerDetails((prev) => (
            { ...prev, [name]: value, driverIds: Array.from(formRef.current.querySelectorAll('.my-3')).map((input) => input.value) }));
    }, []);


    const deleteDriver = (userId) => {
        Swal.fire({
            title: 'Are you sure?',
            text: 'You will not be able to recover this item!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes, delete it!',
            cancelButtonText: 'No, keep it'
        }).then((result) => {
            if (result.isConfirmed) {

                axios.delete(GET_DELETE_ASSIGNED_DRIVER + '/' + `${userId}`)
                    .then((response) => {
                        if (response.data.status === 200) {
                            toast.success(response.data.message, { position: "top-center" });
                            setEditDriverDetails(
                                editDriverDetails.filter(a =>
                                    a.user_id !== `${userId}`
                                )
                            );
                        } else {
                            toast.error(response.data.message, { position: "top-center" });
                        }
                        //console.log(response);
                    }).catch(error => {
                        toast.error(error, { position: "top-center" });
                    })
                //alert(userId);


            }
        });

    }
    const handleKeyDown = (e) => {
        const value = e.target.value;
        const allowedKeys = [
            'Backspace',
            'Delete',
            'ArrowLeft',
            'ArrowRight',
            'Tab',
        ];
        const isNumberKey = /^[0-9]$/.test(e.key);
        if ((!isNumberKey && !allowedKeys.includes(e.key)) ||
            (e.target.value.length >= 8 && !allowedKeys.includes(e.key))
        ) {
            e.preventDefault();
        }
    };

    return (
        <>
            <style>{`
            @keyframes passenger-view-spinner-spin {
                from { transform: rotate(0deg); }
                to { transform: rotate(360deg); }
            }
            .passenger-view-spinner-ring {
                animation: passenger-view-spinner-spin 1s linear infinite;
                border-top-color: transparent;
            }
        `}</style>
            <div className="tab-pane fade active show" id="add-passenger" role="tabpanel" aria-labelledby="home-tab" style={{ position: 'relative' }}>
                {passengerDataLoading && (
                    <div
                        style={{
                            position: 'fixed',
                            top: 0,
                            left: 0,
                            right: 0,
                            bottom: 0,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            backgroundColor: 'rgba(255, 255, 255, 0.4)',
                            backdropFilter: 'blur(8px)',
                            WebkitBackdropFilter: 'blur(8px)',
                            zIndex: 1050,
                        }}
                        aria-busy="true"
                        aria-live="polite"
                    >
                        <div style={{ position: 'relative', width: 96, height: 96, display: 'flex', alignItems: 'center', justifyContent: 'center' }} role="status" aria-label="Loading">
                            <div
                                className="passenger-view-spinner-ring"
                                style={{
                                    position: 'absolute',
                                    inset: 0,
                                    border: '2px solid rgba(13, 93, 90, 0.2)',
                                    borderTopColor: '#0d5d5a',
                                    borderRadius: '50%',
                                }}
                            />
                        </div>
                    </div>
                )}
                <section>
                    <div className='d-flex justify-content-between form-container'>
                        <div>
                            <h2 className="fs-5 font-weight-600"> Edit Passenger</h2>
                        </div>
                        <div>
                            <ToastContainer />
                        </div>
                        <div>
                            <span>{currentDateFormat(currentDate)}</span>
                        </div>
                    </div>
                </section>
                <section>
                    <div className='bg-white  px-5 py-4'>
                        <div>
                            <p className="sub-title">Personal Information</p>
                        </div>

                        <form onSubmit={handleFormSubmit} ref={formRef}>

                            <div className="form-items">
                                <div>
                                    <label className='require-field'>First Name</label>
                                    <input type="text" className="form-control" defaultValue={viewDetails?.passenger_first_name ?? ''} autoComplete='off' id="first_name" name="first_name" placeholder="" onChange={handleInputChange} />
                                    {errors.first_name && <span className='errors'>{errors.first_name}</span>}
                                </div>
                                <div>
                                    <label>Middle Name</label>
                                    <input type="text" className="form-control" defaultValue={viewDetails?.passenger_middle_name ?? ''} autoComplete='off' id="middle_name" name="middle_name" placeholder="" onChange={handleInputChange} />
                                </div>
                                <div>
                                    <label className='require-field'>Last Name</label>
                                    <input type="text" className="form-control" defaultValue={viewDetails?.passenger_last_name ?? ''} autoComplete='off' id="last_name" name="last_name" placeholder="" onChange={handleInputChange} />
                                    {errors.last_name && <span className='errors'>{errors.last_name}</span>}
                                </div>
                                <div>
                                    <label>Preferred Name</label>
                                    <input type="text" className="form-control" defaultValue={viewDetails?.preferred_name ?? ''} autoComplete='off' id="preferred_name" name="preferred_name" placeholder="" onChange={handleInputChange} />
                                </div>
                                <div>
                                    <label className='require-field'>Gender</label>
                                    <div>
                                        <select className="form-select" aria-label="Default select example" value={viewDetails?.gender} name="gender" onChange={handleInputChange}>
                                            <option value="">Select</option>
                                            <option value="1">Male</option>
                                            <option value="2">Female</option>
                                        </select>
                                    </div>
                                    {errors.gender && <span className='errors'>{errors.gender}</span>}
                                </div>
                                <div className="date-selector">
                                    <label className='require-field'>Date of Birth</label>

                                    <Calender
                                        selected={birthDate}
                                        onChange={handleInputChange}
                                        setDate={setBirthDate}
                                        name="date_of_birth"
                                        id="date_of_birth"
                                        errors={errors.date_of_birth}
                                        isClearable={false} />
                                </div>
                                {/* <div>
                                <label>Insurance Number</label>
                                <input 
                                type="text" 
                                className="form-control" 
                                defaultValue={viewDetails?.data?.passenger?.pass_insurance_no ?? ''} 
                                autoComplete='off' 
                                id="insurance_number" 
                                name="insurance_number" 
                                onKeyDown={allowOnlyNumberKey}
                                onChange={handleInputChange} />
                            </div> */}
                                <div>
                                    <label className='require-field'>Member ID/Insurance Number</label>
                                    <input type="text"
                                        className="form-control"
                                        value={passengerDetails?.pmi_number ?? ''}
                                        autoComplete='off'
                                        id="pmi_number"
                                        name="pmi_number"
                                        onChange={handleInputChange}
                                    // onKeyDown={handleKeyDown} 
                                    />
                                    {errors.pmi_number && <span className='errors'>{errors.pmi_number}</span>}
                                </div>
                                <div>
                                    <label>Payer</label>
                                    {/* <input type="text" className="form-control" defaultValue={viewDetails?.data?.passenger?.pass_payer ?? ''} autoComplete='off' id="payer" name="payer" placeholder="" onChange={handleInputChange} /> */}
                                    <select className="form-select" value={passengerDetails?.payer ?? ''} id="payer" name="payer" onChange={handleInputChange}>
                                        <option value="">Select</option>
                                        {payerList.map((payer, index) =>
                                            <option key={index} value={payer.id}>{payer.payer_name}</option>
                                        )
                                        }

                                    </select>
                                </div>
                                <div>
                                    <label>Location</label>
                                    <input type="text" className="form-control" defaultValue={viewDetails?.passenger?.pass_location ?? ''} autoComplete='off' id="location" name="location" placeholder="" onChange={handleInputChange} />
                                </div>
                                <div>
                                    <label className='require-field'>Address Line 1</label>
                                    <input type="text" className="form-control" defaultValue={viewDetails?.address_1 ?? ''} autoComplete='off' id="address_line_one" name="address_line_one" placeholder="" onChange={handleInputChange} />
                                    {errors.address_line_one && <span className='errors'>{errors.address_line_one}</span>}
                                </div>
                                <div>
                                    <label>Address Line 2</label>
                                    <input type="text" className="form-control" defaultValue={viewDetails?.address_2 ?? ''} autoComplete='off' id="address_line_two" name="address_line_two" placeholder="" onChange={handleInputChange} />
                                </div>
                                <div>
                                    <label className='require-field'>City</label>
                                    <input type="text" className="form-control" value={passengerDetails?.city ?? ''} autoComplete='off' id="city" name="city" onChange={handleInputChange} />
                                    {errors.city && <span className='errors'>{errors.city}</span>}
                                </div>
                                <div>
                                    <label className='require-field'>State</label>
                                    <select className="form-select" value={passengerDetails?.state != null && passengerDetails?.state !== '' ? String(passengerDetails.state) : ''} onChange={handleInputChange} aria-label="Default select example" id='state' name="state">
                                        <option value="">Select</option>
                                        {stateData.map((st, index) => (
                                            <option key={index} value={String(st.state_id)}>{st.state_name}</option>
                                        ))}
                                    </select>
                                    {errors.state && <span className='errors'>{errors.state}</span>}
                                </div>
                                <div>
                                    <label>County</label>
                                    <input type="text" className="form-control" autoComplete='off' defaultValue={viewDetails?.passenger?.pass_county ?? ''} id="county" name="county" onChange={handleInputChange} />
                                </div>
                                <div>
                                    <label className='require-field'>Zip</label>
                                    <input type="text" className="form-control" onInput={restrictZipInput} value={passengerDetails?.zip != null ? String(passengerDetails.zip) : ''} autoComplete='off' id="zip" name="zip" onChange={handleInputChange} />
                                    {errors.zip && <span className='errors'>{errors.zip}</span>}
                                </div>
                                <div>
                                    <label>Home Phone Number</label>
                                    <InputMask className="form-control" autoComplete='off' value={viewDetails?.passenger?.pass_home_phn_no ?? ''} mask="(999) 999-9999" id="home_phone" name="home_phone" onChange={handleInputChange}></InputMask>
                                    {/* <input type="text" className="form-control" id="home_phone" name="home_phone"  onChange={handleInputChange} /> */}
                                    {errors.home_phone && <span className='errors'>{errors.home_phone}</span>}
                                </div>
                                <div>
                                    <label className='require-field'>Cell Phone Number</label>
                                    {/* <input type="text" className="form-control"  id="cell_phone" name="cell_phone" onChange={handleInputChange} placeholder="(612) 726-5555" /> */}
                                    <InputMask className="form-control" autoComplete='off' mask="(999) 999-9999" value={viewDetails?.passenger?.pass_cell_phn ?? ''} id="cell_phone" name="cell_phone" onChange={handleInputChange}></InputMask>
                                    {errors.cell_phone && <span className='errors'>{errors.cell_phone}</span>}
                                    {/* <div className="form-check pt-2">
                                    <input className="form-check-input"
                                        type="checkbox" value="" id="pick-up-phone" name="pick_phone" ref={checkboxRef}
                                        onChange={handleInputChange} />
                                    <label className="form-check-label" htmlFor="flexCheckDefault">
                                        Pick Up Phone
                                    </label>
                                </div> */}
                                </div>
                                <div>
                                    <label>Alternate Phone Number</label>
                                    <InputMask className="form-control" autoComplete='off' value={viewDetails?.passenger?.pass_alternative_phn ?? ''} mask="(999) 999-9999" id="alternative_phone" name="alternative_phone" onChange={handleInputChange}></InputMask>
                                </div>
                                {viewDetails?.user_email ? (
                                    <div className="form-item">
                                        <label>Email Address</label>
                                        <input
                                            type="email"
                                            className="form-control"
                                            value={passengerDetails?.email_address ?? ''}
                                            autoComplete="off"
                                            onChange={handleInputChange}
                                            id="email_address"
                                            name="email_address"
                                        />
                                    </div>
                                ) : null}
                                {viewDetails?.username ? (
                                    <div className="form-item">
                                        <label>Username</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            value={passengerDetails?.username ?? ''}
                                            autoComplete="off"
                                            onChange={handleInputChange}
                                            id="username"
                                            name="username"
                                        />
                                    </div>
                                ) : null}

                                <div>

                                    <label>Home Type</label>
                                    <div>
                                        <select className="form-select" value={viewDetails?.home_type} onChange={handleInputChange} aria-label="Default select example" id="home_type" name="home_type">
                                            <option value="">Select</option>
                                            <option value="1">Residence</option>
                                        </select>
                                    </div>
                                </div>
                                <div>
                                    <label>Mode</label>
                                    <div>
                                        <select className="form-select" value={viewDetails?.mode ?? ''} onChange={handleInputChange} aria-label="Default select example" id='mode' name="mode">
                                            <option value="">Select</option>
                                            <option value="1">Option 1</option>
                                        </select>
                                    </div>
                                </div>
                                <div>
                                    <label>Weight</label>
                                    <input type="text" defaultValue={viewDetails?.passenger?.pass_weight ?? ''} onChange={handleInputChange} autoComplete='off' className="form-control" id="weight" name="weight" />
                                </div>
                                <div className="date-selector">
                                    <label>WC Expiry Date</label>
                                    <Calender
                                        selected={startDate}
                                        onChange={handleInputChange}
                                        setDate={setStartDate}
                                        name="wc_expiry_date"
                                        id="wc_expiry_date"
                                        errors={errors.wc_expiry_date} />
                                </div>
                                <div>
                                    <label>Visit Frequency</label>
                                    <div>
                                        <select className="form-select" aria-label="Default select example" value={viewDetails?.passenger?.visit_frequency ?? ''} name="visit_frequency" onChange={handleInputChange}>

                                            <option value="1">Recurring</option>
                                            <option value="2">One Time</option>
                                        </select>
                                    </div>

                                </div>
                                <div className="d-flex flex-wrap gap-3 align-items-center">
                                    <div>
                                        <span className="fw-medium">Oxygen</span>
                                    </div>
                                    <div className="form-check">
                                        <input
                                            className="form-check-input"
                                            type="radio"
                                            id="oxy_yes"
                                            name="oxy"
                                            value="0"
                                            autoComplete="off"
                                            checked={String(passengerDetails?.oxy) === '0'}
                                            onChange={handleInputChange}
                                        />
                                        <label className="form-check-label" htmlFor="oxy_yes">Yes</label>
                                    </div>
                                    <div className="form-check">
                                        <input
                                            className="form-check-input"
                                            type="radio"
                                            id="oxy_no"
                                            name="oxy"
                                            value="1"
                                            autoComplete="off"
                                            checked={String(passengerDetails?.oxy) === '1'}
                                            onChange={handleInputChange}
                                        />
                                        <label className="form-check-label" htmlFor="oxy_no">No</label>
                                    </div>
                                </div>
                                <div className="d-flex flex-wrap gap-3 align-items-center mt-2">
                                    <div>
                                        <span className="fw-medium">Bariatric</span>
                                    </div>
                                    <div className="form-check">
                                        <input
                                            className="form-check-input"
                                            type="radio"
                                            id="bari_yes"
                                            name="bari"
                                            value="0"
                                            autoComplete="off"
                                            checked={String(passengerDetails?.bari) === '0'}
                                            onChange={handleInputChange}
                                        />
                                        <label className="form-check-label" htmlFor="bari_yes">Yes</label>
                                    </div>
                                    <div className="form-check">
                                        <input
                                            className="form-check-input"
                                            type="radio"
                                            id="bari_no"
                                            name="bari"
                                            value="1"
                                            autoComplete="off"
                                            checked={String(passengerDetails?.bari) === '1'}
                                            onChange={handleInputChange}
                                        />
                                        <label className="form-check-label" htmlFor="bari_no">No</label>
                                    </div>
                                </div>
                            </div>
                            <div className="my-4">
                                <p className='sub-title'>Emergency Contact Information</p>
                                <div className="form-items">
                                    <div>
                                        <label>First Name</label>
                                        <input type="text" className="form-control" defaultValue={viewDetails?.emergency_contact_name ?? ''} autoComplete='off' onChange={handleInputChange} id="e_first_name" name="e_first_name" />
                                    </div>
                                    <div>
                                        <label>Last Name</label>
                                        <input type="text" className="form-control" defaultValue={viewDetails?.emergency_email ?? ''} autoComplete='off' onChange={handleInputChange} id="e_last_name" name="e_last_name" />
                                    </div>
                                    <div>
                                        <label>Cell Phone Number</label>
                                        <InputMask className="form-control" value={viewDetails?.emergency_phn ?? ''} autoComplete='off' mask="(999) 999-9999" id="e_cell_number" name="e_cell_number" onChange={handleInputChange}></InputMask>
                                        {/* <input type="text" className="form-control"  onChange={handleInputChange} id="e_cell_number" name="e_cell_number"  /> */}
                                    </div>
                                    <div className="form-item">
                                        <label>Email Address</label>
                                        <input type="email" autoComplete='off' defaultValue={viewDetails?.emergency_email ?? ''} className="form-control" onChange={handleInputChange} id="e_email" name="e_email" />
                                    </div>
                                </div>
                            </div>
                            <div className="pb-3">
                                <p className='sub-title'>Responsible Party Information</p>
                                <div className="form-items">
                                    <div>
                                        <label>First Name</label>
                                        <input type="text" className="form-control" defaultValue={viewDetails?.passenger?.resp_party_first_name ?? ''} autoComplete='off' onChange={handleInputChange} id="r_first_name" name="r_first_name" />
                                    </div>
                                    <div>
                                        <label>Last Name</label>
                                        <input type="text" autoComplete='off' defaultValue={viewDetails?.passenger?.resp_party_last_name ?? ''} className="form-control" onChange={handleInputChange} id="r_last_name" name="r_last_name" />
                                    </div>
                                    <div>
                                        <label>Cell Phone Number</label>
                                        <InputMask className="form-control" autoComplete='off' value={viewDetails?.passenger?.resp_party_phn_no ?? ''} mask="(999) 999-9999" id="r_cell_number" name="r_cell_number" onChange={handleInputChange}></InputMask>
                                        {/* <input type="text" className="form-control" onChange={handleInputChange} id="r_cell_number" name="r_cell_number"  /> */}
                                    </div>
                                    <div className="form-item">
                                        <label>Email Address</label>
                                        <input type="email" autoComplete='off' defaultValue={viewDetails?.passenger?.resp_party_email ?? ''} className="form-control" onChange={handleInputChange} id="r_email" name="r_email" />
                                    </div>
                                </div>
                            </div>
                            <div className="my-4">
                                <p className='sub-title'>Billing Information</p>
                                <div className="form-items">
                                    <div>
                                        <label>Diagnosis Code</label>
                                        <div>
                                            <select className="form-select" aria-label="Default select example" value={viewDetails?.passenger?.diagnosis_code ?? ''} name="diagnosis_code" onChange={handleInputChange}>

                                                <option value="Z00.8">Z00.8</option>
                                                <option value="Z02.89">Z02.89</option>
                                            </select>
                                        </div>

                                    </div>

                                </div>
                            </div>
                            <div className='footer-content'>
                                {/* <button type='submit' className='btn save-btn default-btn add-passenger-btn'>Save Passenger</button> */}

                                <SaveButton
                                    type="submit"
                                    buttonTitle="UPDATE PASSENGER"
                                    loading={isUpdatingPassenger}
                                    loadingText="Updating..."
                                />

                                <CancelButton cancelHandler={() => navigate('/home/passenger/list', { replace: true })} />
                            </div>
                        </form>

                    </div>
                </section>
                {/* <div>
    <Auto/>
    </div> */}
            </div><div>
                {loading && <Loader />}
            </div></>
    )

}

export default PassengerView